// Version : 0.0.2
// Author : DINESH
// MODFIED DATA : 07-08-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/*************** STAFF DETAILS ADD START *************** */
export const staffListGet = (listData: any) => {
	const data = {
		GetStaffBasedOnCompanyToken: listData,
	};
	// const url = `${API_URL}getStaffList`;
	const url = `${API_URL}staffBasedOnComapany`;
	return makeApiCall(url, data);
};
/*************** STAFF DETAILS ADD END *************** */

/*************** STAFF DETAILS PUBLISH UPDATE START *************** */
export const staffPublishStatusUpdate = (deleteData: any) => {
	const data = {
		UpdateStaffPublishToken: deleteData,
	};
	const url = `${API_URL}updatePublishStatus`;
	return makeApiCall(url, data);
};
/*************** STAFF DETAILS PUBLISH UPDATE END *************** */

/*************** STAFF DETAILS DELETE START *************** */
export const staffDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteStaffDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteStaffDetails`;
	return makeApiCall(url, data);
};
/*************** STAFF DETAILS DELETE END *************** */

/*************** STAFF DETAILS ADD START *************** */
export const staffDetailsAdd = (addData: any) => {
	const data = {
		AddStaffDetailsToken: addData,
	};
	const url = `${API_URL}addStaffDetails`;
	return makeApiCall(url, data);
};
/*************** STAFF DETAILS ADD END *************** */

/*************** STAFF DETAILS FETCH START *************** */
export const staffDetailsFetch = (fetchData: any) => {
	const data = {
		FetchStaffDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchStaffDetails`;
	return makeApiCall(url, data);
};
/*************** STAFF DETAILS FETCH END *************** */

/*************** STAFF DETAILS UPDATE START *************** */
export const staffDetailsUpdate = (updateData: any) => {
	const data = {
		UpdateStaffDetailsToken: updateData,
	};
	const url = `${API_URL}updateStaffDetails`;
	return makeApiCall(url, data);
};
/*************** STAFF DETAILS UPDATE END *************** */

/*************** STAFF DETAILS UPDATE ISPRINT START *************** */
export const staffIsPrintStatusUpdate = (deleteData: any) => {
	const data = {
		UpdateStaffIsPrintToken: deleteData,
	};
	const url = `${API_URL}updateIsPrintReceiptAsManagerWithToken`;
	return makeApiCall(url, data);
};
/*************** STAFF DETAILS UPDATE ISPRINT END *************** */

/*************** GET ALL STAFF START *************** */
export const getAllStaffDetails = (listData: any) => {
	const data = {
		GetAllStaffBasedOnCompanyToken: listData,
	};
	const url = `${API_URL}allStaffBasedOnCompany`;
	return makeApiCall(url, data);
};
/*************** GET ALL STAFF END *************** */
